module.exports = __webpack_public_path__ + "static/media/cancel_view-pending-cancellations.0ca89ead.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/cancel_view-pending-cancellations.md
// module id = 1093
// module chunks = 0